//
//
//
//
//
//
export default {
  name: 'content-section',
  props: ['name']
};